import { AuthorizationProvider } from '@frontend/authorization';
import { ModalProvider } from '@frontend/modal';
import { AccountStoreProvider, DocumentStoreProvider } from '@frontend/repository';
import { BrowserRouter as Router } from 'react-router-dom';

import Footer from './home-page/footer/footer.component';
import HomePage from './home-page/home-page.component';
import Navbar from './home-page/navbar/navbar.component';
import Initialisation from './initialisation/initialisation.component';
import { useAppDispatch, useAppSelector } from './redux/store';
import Resolver from './utils/resolver';

export function App() {
    const navigationState = useAppSelector((state) => state.navigation);
    const dispatch = useAppDispatch();

    return (
        <DocumentStoreProvider>
            <Router>
                <AuthorizationProvider
                    dispatch={dispatch}
                    token={navigationState.user?.auth || undefined}>
                    <Initialisation>
                        <AccountStoreProvider>
                            <Resolver>
                                <ModalProvider>
                                    <div
                                        className='app-content d-flex flex-column no-select'
                                        id='app-content'>
                                        <Navbar />
                                        <HomePage />
                                        <Footer />
                                    </div>
                                </ModalProvider>
                            </Resolver>
                        </AccountStoreProvider>
                    </Initialisation>
                </AuthorizationProvider>
            </Router>
        </DocumentStoreProvider>
    );
}

export default App;
